"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInput = void 0;

var React = require("react");

var input_control_1 = require("./input-control");

var maishu_dilu_1 = require("maishu-dilu");

var TextInput = /*#__PURE__*/function (_input_control_1$Inpu) {
  _inherits(TextInput, _input_control_1$Inpu);

  var _super = _createSuper(TextInput);

  function TextInput(props) {
    var _this;

    _classCallCheck(this, TextInput);

    _this = _super.call(this, props);
    _this.state = {};

    if (_this.props.dataType == "number") {
      _this.props.validateRules.push(maishu_dilu_1.rules.numeric("请输入数字"));
    }

    return _this;
  }

  _createClass(TextInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          dataField = _this$props.dataField,
          placeholder = _this$props.placeholder,
          dataType = _this$props.dataType;
      var value = this.state.value;
      return React.createElement("input", {
        name: name || dataField,
        className: "form-control",
        placeholder: placeholder,
        type: this.props.type,
        value: value || "",
        ref: function ref(e) {
          return _this2.input = e || _this2.input;
        },
        onChange: function onChange(e) {
          if (dataType == "number") {
            if (!maishu_dilu_1.rules.numeric().validate(e.target.value)) return;
            var integerRegex = /^\d+$/;

            var _value = integerRegex.test(e.target.value) ? parseInt(e.target.value) : parseFloat(e.target.value);

            _this2.setState({
              value: _value
            });
          }

          _this2.setState({
            value: e.target.value
          });
        }
      });
    }
  }, {
    key: "value",
    get: function get() {
      return this.state.value;
    },
    set: function set(value) {
      this.setState({
        value: value
      });
    }
  }]);

  return TextInput;
}(input_control_1.InputControl);

exports.TextInput = TextInput;
